__webpack_require__.p = "https://dragon.vidletdev.io/";